
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UtilsLocalizedExcelString from '../services/utilsLocalizedExcelString.jsx';


function CountriesPage(props) {

  const { t } = useTranslation();
 const [excelLoadedSheet, setExcelLoadedSheet] = useState(false);
     const [excelDataSheet, setExcelDataSheet]= useState("");
  useEffect(() => {
    


     const handleFetchFromUrl = async () => {
    if(!excelLoadedSheet) {
    try {
      const url = "https://storage.googleapis.com/fgr-data-visualisation-assets/fgr_silvagris_assets.xlsx";
      const response = await axios.get(url, { responseType: 'arraybuffer' });

      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[3];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setExcelDataSheet(jsonData);
      setExcelLoadedSheet(true);
    } catch (error) {
    
      console.error('Error fetching or parsing Excel file:', error);
    }
  }
  };
      handleFetchFromUrl();

  }, [props.lang, excelDataSheet,excelLoadedSheet]);
     return (
      <div className="App" style={{marginTop: "2rem"}}>
      <h5 className="title-body">{t('organisations')}</h5>
      <br></br>
       
      
      <div >{
     
        Array.isArray(excelDataSheet) && 
        excelDataSheet !== undefined && 
        excelDataSheet !== null &&
        excelDataSheet !== "" 
        
        ? 
        <div style={{textAlign: props.lang !== "ar" ? "left" : "right"}} key="country-mapping">{
            excelDataSheet.slice(1).map((item, index) => 
      <div style={{height: "8rem"}} className="country-link" key={index+item[0].replaceAll(" ", "")} >
                {item[1]}
              <div className="d-grid gap-1">
       <Button style={{backgroundColor: "#116AAB",  border:"1px solid #116AAB" , width:"300px", marginTop:"10px"}} size="lg" >
       <a style={{textDecoration: "none", color:"white"}} href={item[2]} target="_blank" rel="noopener noreferrer">
       <span style={{marginLeft: "0.5rem", marginRight: "0.5rem",  verticalAlign: "middle"}}>{item[0]}</span><img style={{verticalAlign: "middle"}} 
       src={process.env.PUBLIC_URL + `/img/box-arrow-up-right.svg`} alt="arrow up right open" />
       </a>
       </Button>
       </div><br></br><br></br><br></br></div>)}
         
            </div>
          : <div></div>}
                             

              


      </div></div>
     )
  }

  export default CountriesPage;